
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/zakwaterowanie",
      function () {
        return require("private-next-pages/[region]/zakwaterowanie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/zakwaterowanie"])
      });
    }
  